import type { GrowthBook } from '@growthbook/growthbook'
import firebase from 'firebase/compat/app'
import {
  Cohort,
  EventLoggerInstanceName,
  RUDDERSTACK_DATA_PLANE_URL,
} from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { Rudderstack } from 'services/rudderstack.service'
import { getFrcEventProps } from './getFrcEventProps'
import { getAbTestOptions } from './getAbTestOptions'
import { getAbTestVariantData } from './getAbTestVariantData'
import { getRemoteConfigVariantData } from './getRemoteConfigVariantData'
import {
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
} from 'constants/ab-tests'
import { getGrowthbookVariantData } from './getGrowthbookVariantData'

export const addRudderstackLogger = ({
  uuid,
  utmTags,
  cohort,
  firebaseRemoteConfig,
  growthbook,
  country,
}: {
  uuid: string
  utmTags: Record<string, string>
  cohort: Cohort
  firebaseRemoteConfig: firebase.remoteConfig.RemoteConfig | null
  growthbook?: GrowthBook | null
  country: string
}): void => {
  const remoteConfigVariantValue = getAbTestVariantData({
    firebaseRemoteConfigVariantData: getRemoteConfigVariantData({
      firebaseRemoteConfig,
      firebaseRemoteConfigKey: COHORT_FIREBASE_KEYS_MAP[cohort],
    }),
    growthbookVariantData: getGrowthbookVariantData({
      growthbook: growthbook || null,
      growthbookKey: COHORT_GROWTHBOOK_KEYS_MAP[cohort],
    }),
    cohort,
    country,
  })

  const intellioAbTestOptions = getAbTestOptions({
    cohort,
    remoteConfigVariantValue,
    country,
  })

  const rudderstackService = new Rudderstack({
    writeKey: import.meta.env.RUDDERSTACK_WRITE_KEY,
    dataPlaneUrl: RUDDERSTACK_DATA_PLANE_URL,
    instanceName: EventLoggerInstanceName.RUDDERSTACK,
    userId: uuid,
    utmTags: {
      ...utmTags,
      uuid,
    },
    cohort,
    options: {
      ...(intellioAbTestOptions || {}),
      ...getFrcEventProps(),
    },
  })

  eventLogger.addLoggers([rudderstackService])
}
